export interface TBBox {
  x: number;
  y: number;
  width: number;
  height: number;
}

function imageBitmapToBase64(imageBitmap: ImageBitmap): string {
  // 1. Create a canvas element
  const canvas = document.createElement('canvas');
  canvas.width = imageBitmap.width;
  canvas.height = imageBitmap.height;

  // 2. Draw the ImageBitmap onto the canvas
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('could not get Canvas 2d context');
  ctx.drawImage(imageBitmap, 0, 0);

  // 3. Convert canvas to Data URL (Base64)
  const result = canvas.toDataURL('image/jpeg'); // or 'image/jpeg'
  canvas.remove();
  return result;
}

export interface CutBboxFromImageProps {
  image: ImageBitmapSource;
  bbox: TBBox;
}
export async function cutBboxFromImage({
  image,
  bbox,
}: CutBboxFromImageProps): Promise<string> {
  const imageBitmap = await createImageBitmap(image, bbox.x, bbox.y, bbox.width, bbox.height);
  return imageBitmapToBase64(imageBitmap);
}
